import React from 'react';
import { Card, CardContent } from '@tmap/mmm-style-guide/src/Card';
import { Grid } from '@tmap/mmm-style-guide/src/Grid';
import { styled } from '@tmap/mmm-style-guide/src/styled';
import { Typography } from '@tmap/mmm-style-guide/src/Typography';
import { Button } from '@tmap/mmm-style-guide/src/Button';
import imageUrlBuilder from "@sanity/image-url";
import client from '../../client';

const builder = imageUrlBuilder(client);

const SANITY_COLLAGE_URL = 'https://cdn.sanity.io/images/u721u3r1/production/cfd820430817f59dfbd18af7bf2a9aa1b36be96b-128x433.png';
const SANITY_VILLAGE_URL = 'https://cdn.sanity.io/images/u721u3r1/production/06d56432cc1b1f874995e72397a0cb24fc5ae655-56x57.png';

const CTACard = styled(Card)(({ theme }) => ({
  backgroundColor: theme.palette.grey[50],
  height: '100%',
  padding: '24px 0 24px 20px',
  borderRadius: '8px',
}));

const SubmitPostCTACard = ({ onPostClick }) => {
  return (
    <CTACard elevation={1}>
      <CardContent sx={{ height: '100%' }}>
        <Grid container spacing={2}>
          <Grid item xs={7} md={8} lg={7}>
            <img src={builder.image(SANITY_VILLAGE_URL).url()}
              width={56}
              height={57}
            />
            <Typography variant='h6' sx={{ my: '12px' }}>Tell us about your community</Typography>
            <Typography variant='body2'>We’d love to know more – be one of the first to post in your area!</Typography>
            <Button
              variant='contained'
              color='inverted'
              sx={{ marginTop: '20px' }}
              onClick={onPostClick}>
              Submit a Post
            </Button>
          </Grid>
          <Grid item xs={5} md={4} lg={5} sx={{ position: 'relative' }}>
            <img src={builder.image(SANITY_COLLAGE_URL).url()} style={{ position: 'absolute', top: '-24px' }}
            />
          </Grid>
        </Grid>
      </CardContent>
    </CTACard>
  )
}

export default SubmitPostCTACard;